import React, { memo } from 'react';
import Paginacion from '../../../Reutilizables/Paginacion';

const money = (v) => Number(v || 0).toLocaleString('es-PE', { style: 'currency', currency: 'PEN' });

const RentaTable = ({
  rows = [],
  loading = false,
  error = '',
  pagination = null,
  onPageChange = null
}) => {
  return (
    <>
      {error && (
        <div className="mt-3 bg-red-50 text-red-700 p-4 rounded-lg border border-red-200">
          {error}
        </div>
      )}

      <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gray-500 bg-gray-50 border-b border-gray-200">
                <th className="py-3 px-3 text-center">PRÉSTAMO</th>
                <th className="py-3 px-3 text-center">CLIENTE</th>
                <th className="py-3 px-3 text-center">ASESOR</th>
                <th className="py-3 px-2 text-center">N° CUOTA</th>
                <th className="py-3 px-3 text-center">MONTO ABONADO</th>
                <th className="py-3 px-3 text-center">MONTO CUOTA</th>
                <th className="py-3 px-3 text-center">CAPITAL</th>
                <th className="py-3 px-3 text-center">INTERÉS</th>
                <th className="py-3 px-3 text-center">F. VENC.</th>
                <th className="py-3 px-3 text-center">F. CANCEL.</th>
                <th className="py-3 px-3 text-center">HORARIO DE PAGO</th>
                <th className="py-3 px-4 text-center" style={{ minWidth: '140px' }}>ABONADO POR</th>
              </tr>
            </thead>

            <tbody>
              {rows.length === 0 && (
                <tr>
                  <td className="py-8 px-4 text-center text-gray-500" colSpan={12}>
                    {loading ? 'Cargando…' : 'Sin resultados'}
                  </td>
                </tr>
              )}

              {rows.map((r) => {
                return (
                  <tr
                    key={`${r.id_prestamo}-${r.id_cuota}`}
                    className="border-b border-gray-200 last:border-b-0 transition hover:bg-rose-50/40 odd:bg-white even:bg-gray-50/40"
                  >
                    <td className="py-3 px-3">
                      <div className="flex flex-col items-center text-center gap-1">
                        <span className="font-medium text-gray-900">#{r.id_prestamo}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full w-fit ${r.prestamo?.estado === 'activo'
                              ? 'bg-green-100 text-green-700'
                              : r.prestamo?.estado === 'cancelado'
                                ? 'bg-gray-100 text-gray-700'
                                : 'bg-red-50 text-red-600'
                            }`}
                        >
                          {r.prestamo?.estado?.toUpperCase() || '-'}
                        </span>
                      </div>
                    </td>


                    <td className="py-3 px-3">
                      <div className="flex items-center gap-2">
                        <div className="flex flex-col">
                          <span className="font-medium text-gray-900 text-xs">
                            {r.cliente?.nombre || 'Sin nombre'}
                          </span>
                          <span className="text-xs text-gray-500">
                            DNI: {r.cliente?.dni || 'No disponible'}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td className="py-3 px-3">
                      <div className="flex items-center gap-2">
                        <div className="flex flex-col">
                          <span className="font-medium text-gray-900 text-xs">
                            {r.asesor?.nombre}
                          </span>
                        </div>
                      </div>
                    </td>

                    <td className="py-2 px-2 text-center">
                      <span className="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800">
                        {r.nro_cuota}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className="font-semibold text-gray-900">
                        {money(r.monto_abonado)}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className="font-semibold text-gray-900">
                        {money(r.monto_cuota)}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className="font-semibold text-gray-900">
                        {money(r.capital)}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className="font-semibold text-gray-900">
                        {money(r.interes)}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className="text-xs font-medium text-gray-900">
                        {r.fecha_vencimiento || '-'}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className="text-xs font-medium text-gray-900">
                        {r.fecha_cancelacion || '-'}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className="text-xs font-medium text-gray-900">
                        {r.horario_pago || '-'}
                      </span>
                    </td>

                    <td className="py-3 px-4 text-center" style={{ minWidth: '140px' }}>
                      <span className={`text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap ${r.prestamo?.abonado_por === 'CUENTA CORRIENTE'
                          ? 'bg-red-100 text-red-800 border border-red-200'
                          : r.prestamo?.abonado_por === 'CAJA CHICA'
                            ? 'bg-yellow-100 text-yellow-800 border border-yellow-200'
                            : 'bg-gray-100 text-gray-500'
                        }`}>
                        {r.prestamo?.abonado_por || 'N/A'}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        {loading && rows.length > 0 && (
          <div className="p-4">
            <div className="mx-auto h-1 w-32 bg-gray-100 rounded overflow-hidden">
              <div className="h-full w-1/2 animate-pulse bg-red-600"></div>
            </div>
          </div>
        )}

        {/* Paginación */}
        {pagination && pagination.last_page > 1 && (
          <div className="p-4 border-t border-gray-200">
            <Paginacion
              paginacion={{
                pagina_actual: pagination.current_page,
                ultima_pagina: pagination.last_page,
                desde: pagination.from,
                hasta: pagination.to,
                total: pagination.total
              }}
              alCambiarPagina={onPageChange}
              cargando={loading}
              nombreItem="registros"
              colorTema="red"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default memo(RentaTable);
